import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NovoUnidadeJurisdicional } from '../modelos/novoUnidadeJurisdicional';
import { Filtro } from '../paginas/paginas-setoriais/paginas-setoriais.component';
import { ApiConfig, Path, SiteAdmApiConfig } from '../util/path';

@Injectable({
  providedIn: 'root'
})
export class NovoUnidadeJurisdicionalService {

  private token: String;

  constructor(private httpClient: HttpClient) {
    this.token = ApiConfig.API_TOKEN;
  }

  private getCabecalho() {
    let cabecalho = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        //'Authorization': 'Bearer ' + this.token,
      })
    };
    return cabecalho;
  }

  buscarRegistros(): Observable<NovoUnidadeJurisdicional> {
    let pagina = 0;

    let url = SiteAdmApiConfig.API_URL +
      `${Path.PAGINAS_SETORIAIS.nomeService}/v1/external/unidade-jurisdicional`;

    return this.httpClient.get<NovoUnidadeJurisdicional>(url, this.getCabecalho());
  }

  buscarRegistrosPorMunicipios(id: string[]): Observable<NovoUnidadeJurisdicional> {
    let pagina = 0;

    let url = SiteAdmApiConfig.API_URL +
      `${Path.PAGINAS_SETORIAIS.nomeService}/v1/external/unidade-jurisdicional?`;

    for(let item of id){
      url += `&idsMunicipios=${item}`;
    }

    return this.httpClient.get<NovoUnidadeJurisdicional>(url, this.getCabecalho());
  }

  buscarUjPorMunicipios(id: string[]): Observable<NovoUnidadeJurisdicional> {
    let pagina = 0;

    let url = SiteAdmApiConfig.API_URL +
      `${Path.PAGINAS_SETORIAIS.nomeService}/v1/external/unidade-jurisdicional/uj?`;

    for(let item of id){
      url += `&idsMunicipios=${item}`;
    }

    return this.httpClient.get<NovoUnidadeJurisdicional>(url, this.getCabecalho());
  }

  buscarUnidadeJurisdicionalPorId(id: string): Observable<NovoUnidadeJurisdicional>{
    let url = SiteAdmApiConfig.API_URL +
      `${Path.PAGINAS_SETORIAIS.nomeService}/v1/external/unidade-jurisdicional/${id}`;
    return this.httpClient.get<NovoUnidadeJurisdicional>(url, this.getCabecalho());
  }

  buscarUnidadeJurisdicionalPorNome(nome: string): Observable<NovoUnidadeJurisdicional>{
    let url = SiteAdmApiConfig.API_URL +
      `${Path.PAGINAS_SETORIAIS.nomeService}/v1/external/unidade-jurisdicional/nome?&nome=${nome}`;
    return this.httpClient.get<NovoUnidadeJurisdicional>(url, this.getCabecalho());
  }
}
